type PropTypes = {
  className?: string
}

const ProfileIcon = ({ className }: PropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 17 18"
      className={className}
    >
      <path fill="currentColor" d="M8.47 4.777a2.647 2.647 0 1 0 0 5.294 2.647 2.647 0 0 0 0-5.294Z" />
      <path fill="currentColor" d="M8.47 1.6a7.412 7.412 0 1 0 7.412 7.412A7.42 7.42 0 0 0 8.47 1.601Zm4.232 12.138a2.648 2.648 0 0 0-2.643-2.608H6.882a2.648 2.648 0 0 0-2.643 2.608 6.353 6.353 0 1 1 8.463 0Z" />
    </svg>
  )
}

export default ProfileIcon
